import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchLuName: [],
  searchObjId: "",
  searchKeyRef: "",
  whereClause: "",
  pivotSelectedKey: "",
  selectedKeyLuName: "",
};

const searchSlice = createSlice({
  name: "checkin/search",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_SEARCH_LUNAME", (state, action) => {
        state.searchLuName = action.payload;
      })
      .addCase("ON_SEARCH_OBJ_ID", (state, action) => {
        state.searchObjId = action.payload;
      })
      .addCase("ON_SEARCH_KEY_REF", (state, action) => {
        state.searchKeyRef = action.payload;
      })
      .addCase("ON_WHERE_CLAUSE_CHANGED", (state, action) => {
        state.whereClause = action.payload;
      })
      .addCase("ON_PIVOT_SELECTEDKEY_CHANGED", (state, action) => {
        state.pivotSelectedKey = action.payload;
      })
      .addCase("ON_SELECTEDKEY_LUNAME_CHANGED", (state, action) => {
        state.selectedKeyLuName = action.payload;
      });
  },
});

export default searchSlice.reducer;
